export default __webpack_public_path__ + "static/media/2.ddf3ebb0.jpg";